import { z } from "zod";

const requiredMessage = "validators.required";

export const caloriesCalculatorSchema = z.object({
  gender: z.enum(["female", "male"]),
  goal: z.enum(["eat-healthier", "maintain", "lose-weight", "build-muscle"], {
    message: requiredMessage,
  }),
  activityLevel: z.enum(["low", "moderate", "high"], {
    message: requiredMessage,
  }),
  height: z.string().min(1, { message: requiredMessage }),
  weight: z.string().min(1, { message: requiredMessage }),
  age: z.string().min(1, { message: requiredMessage }),
});

export type CaloriesCalculatorFormType = z.infer<
  typeof caloriesCalculatorSchema
>;
